import ColorKeys from '../../constants/ColorKeys';

export function createCommandButton(text, isDisable) {
  return this.rexUI.add.label({
    width: 100,
    height: 40,
    background: this.rexUI.add.roundRectangle(0, 0, 0, 0, 14, ColorKeys.Grey),
    text: this.add.text(0, 0, text, {
      fontSize: 18,
      color: !isDisable ? '#000' : '#808080',
    }),
    align: 'center',
    space: {
      left: 10,
      right: 10,
    },
  });
}

export function createRow(data) {
  const nameLabel = this.add.text(0, 0, data.name, {
    fontSize: '18px',
    color: '#000',
  });

  const contentLabel = this.add.text(0, 0, data.content, {
    fontSize: '18px',
    color: '#000',
  });

  const sizer = this.rexUI.add.sizer({
      orientation: 'x',
    })
    .add(this.rexUI.add.label({
      width: 220,
      text: nameLabel,
      align: 'left',
    }))
    .add(contentLabel);

  return sizer;
}

export function createTable(x, y, width, height, table) {
  const sizer = this.rexUI.add.sizer(x, y, width, height, {
    orientation: 'y',
  })
  .addBackground(this.rexUI.add.roundRectangle(0, 0, 0, 0, 14, ColorKeys.Grey))

  const padding = {
    top: 16,
    bottom: 16,
    left: 16,
    right: 16,
  }

  const { data } = table;

  for (let i = 0, cnt = data.length; i < cnt; i++) {
    sizer.add(createRow.call(this, data[i]), 0, 'left', padding);
  }

  sizer.layout();

  return sizer;
}
